import { request } from '@/utils/request'
const ProjectManageService = {
  state: {},

  mutations: {},

  actions: {
    // 项目分区管理分页
    GetAllAssetsPublicSection({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Assets/AssetsPublicSection/GetAllAssetsPublicSection', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存项目
    SaveProjectregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Assets/AssetsPublicSection/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除项目
    DeleteProjectregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Assets/AssetsPublicSection/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default ProjectManageService
